import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Operations from "@/components/Operations";
import Careers from "@/components/Careers";
import Branches from "@/components/Branches";
import Leadership from "@/components/Leadership";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const WhatsAppButton = () => (
  <a
    href="https://wa.me/917907440408"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-button"
    aria-label="Chat with Techworld Business Group on WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-110"
  >
    <MessageCircle size={26} />
  </a>
);

const Site = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-ink font-sans text-slate-50 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Operations />
        <Careers />
        <Branches />
        <Leadership />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Site />} />
      </Routes>
      <Toaster position="bottom-right" richColors theme="dark" />
    </BrowserRouter>
  );
}

export default App;
